import { Vertical } from "@/components/standard/BFLayout"
import { Body, H4 } from "@/components/standard/BFText"
import { View } from "react-native"
import Tooltips from "@/constants/ToolTips"
import CalculatorItem from "@/components/calculate/CalculatorItem"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { BFColors } from "@/constants/Colors"

/* Copy of current server logic, if we do this "for real" might want to move to server */
const createRangeFromValue = (value?: number | null): [number, number] => {
  const rounding = (value || 0) < 10000 ? 100 : 1000

  return !value
    ? [0, 0]
    : [
        Math.floor((value * 0.97) / rounding) * rounding,
        Math.ceil((value * 1.02) / rounding) * rounding,
      ]
}

export const EstimatedTotalsSection = () => {
  const { loanApplication } = useLoanContext()
  return <EstimatedTotalsNoContext loanApplication={loanApplication} />
}
interface EstimatedTotalsSectionProps {
  loanApplication: {
    contractStatus?: string | null
    estimatedCashToBorrower?: number | null
    estimatedCashToClose?: number | null
    totalLoanAmount?: number | null
    monthlyPayment?: number | null
    financingFee?: number | null
  }
}

export const EstimatedTotalsNoContext = ({
  loanApplication,
}: EstimatedTotalsSectionProps) => {
  const isRefi = loanApplication.contractStatus === "refinance"
  const cashToFromBorrower = isRefi
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Math.abs(loanApplication?.estimatedCashToBorrower || 0)
    : loanApplication?.estimatedCashToClose || 0

  return (
    <Vertical>
      <H4>Estimated Totals</H4>
      <Body>
        These price ranges are an estimate based on information already
        provided. If you choose to apply, a Backflip loan expert will work with
        you to finalize the exact numbers.
      </Body>
      <View className="flex flex-col p-4 mt-2 bg-white border rounded border-light-grey">
        <CalculatorItem
          title="Total Loan Amt"
          range={createRangeFromValue(loanApplication?.totalLoanAmount)}
          tooltip={Tooltips.totalLoanAmount}
        />
        <CalculatorItem
          title="Monthly Payment"
          range={createRangeFromValue(loanApplication?.monthlyPayment)}
        />
        <CalculatorItem
          title="Financing Fees"
          // subtitle={`(Includes ${((loanApplication?.originationRate || 0) * 100).toFixed(2)}% Origination Fee)`}
          range={createRangeFromValue(loanApplication?.financingFee)}
          textColor={BFColors.midnightBlue}
          tooltip={Tooltips.oneTimeFinancing}
        />
        <CalculatorItem
          title={
            isRefi && (loanApplication.estimatedCashToClose || 0) <= 0
              ? "Cash to Borrower"
              : "Cash to Close"
          }
          // subtitle={`(Includes ${((loanApplication?.originationRate || 0) * 100).toFixed(2)}% Origination Fee)`}

          range={createRangeFromValue(cashToFromBorrower)}
          textColor={BFColors.midnightBlue}
          tooltip={!isRefi ? Tooltips.oneTimeFinancing : undefined}
        />
      </View>
    </Vertical>
  )
}
